export default __webpack_public_path__ + "img/exit.77cbab1e.svg";